import { connect } from 'react-redux'
import { compose, withState, withProps, branch, renderNothing } from 'recompose'
import FIxedNotification from './FixedNotification'
import { GENERAL_SOURCE, YMME_NAME } from 'constant'
import { showNewShopTiresModal } from 'components/NewShopTiresModal/actions.js'

const withNotificationVisibilityState = withState('visible', 'setVisible', true)

const withVehicleSelectorBlockProps = withProps(({
  showNewShopTiresModal
}) => ({
  addVehicle: () => showNewShopTiresModal({
    isOnlyVehicle: true,
    ymmeName: YMME_NAME,
    withShowConfirmTireSizeModal: true,
    source: GENERAL_SOURCE
  })
}))

const withRenderNothing = branch(
  ({ visible }) => !visible,
  renderNothing
)

export default compose(
  connect(null, { showNewShopTiresModal }),
  withNotificationVisibilityState,
  withVehicleSelectorBlockProps,
  withRenderNothing
)(FIxedNotification)
